"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NumberFormatType;
(function (NumberFormatType) {
    NumberFormatType[NumberFormatType["Number"] = 0] = "Number";
    NumberFormatType[NumberFormatType["Short"] = 1] = "Short";
    NumberFormatType[NumberFormatType["Percent"] = 2] = "Percent";
})(NumberFormatType = exports.NumberFormatType || (exports.NumberFormatType = {}));
var NumberFormatRoundType;
(function (NumberFormatRoundType) {
    NumberFormatRoundType[NumberFormatRoundType["Round"] = 0] = "Round";
    NumberFormatRoundType[NumberFormatRoundType["Ceil"] = 1] = "Ceil";
    NumberFormatRoundType[NumberFormatRoundType["Floor"] = 2] = "Floor";
    NumberFormatRoundType[NumberFormatRoundType["Truncate"] = 3] = "Truncate";
})(NumberFormatRoundType = exports.NumberFormatRoundType || (exports.NumberFormatRoundType = {}));
;
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ../player-globalization/types.js
// module id = 177
// module chunks = 0 1